"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processProgressData = exports.exportUserProgressToExcel = void 0;
var _xlsx = _interopRequireDefault(require("xlsx"));
var _lodash = require("lodash");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable @typescript-eslint/comma-dangle */ /* eslint-disable no-param-reassign */ /* eslint-disable object-curly-newline */ /* eslint-disable consistent-return */ /* eslint-disable operator-linebreak */ /* eslint-disable comma-dangle */
var Conclusion = 'Conclusions';
var Explanation = 'Explanation';
var ClickBestSpot = 'ClickBestSpot';
var ProgressColumns = [{
  name: 'Slide #',
  prop: 'num'
}, {
  name: 'Status',
  prop: 'correct'
}, {
  name: '% of Exercise Correct',
  prop: 'percentCorrect'
}, {
  name: 'Choices Submitted',
  prop: 'choices'
}, {
  name: 'Answer Key',
  prop: 'answerKey'
}, {
  name: 'Active Time (h:mm:ss)',
  prop: 'elapsed'
}];
var msToExcelTime = function msToExcelTime(ms) {
  return +ms / 86400000;
};
var ThirtySecs = 30 * 1000;
var ThirtyFiveSecs = 35 * 1000;
var OneMinute = 60 * 1000;
var sumDuration = function sumDuration(summations, duration, leftReviewTime, isLastActiveSum) {
  // If isLastActiveSum is true and duration is greater/equal to 9.5 min, add 30 seconds
  // to account for the final gap before the timer went inactive
  var value = duration + (isLastActiveSum && duration >= 9.25 * OneMinute ? ThirtySecs : 0);
  if (!leftReviewTime) {
    if (!summations.elapsed) {
      summations.elapsed = value;
    } else {
      summations.elapsed += value;
    }
  }
  if (!summations.total) {
    summations.total = value;
  } else {
    summations.total += value;
  }
};
var processProgressData = function processProgressData(_ref) {
  var _lastSlide;
  var _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? [] : _ref$progress,
    _ref$ignoreConclusion = _ref.ignoreConclusion,
    ignoreConclusion = _ref$ignoreConclusion === void 0 ? true : _ref$ignoreConclusion,
    _ref$ignoreExplanatio = _ref.ignoreExplanation,
    ignoreExplanation = _ref$ignoreExplanatio === void 0 ? true : _ref$ignoreExplanatio;
  var processedData = {
    totalSlides: 0,
    slidesCompleted: 0,
    numTries: 0,
    totalTime: 0,
    totalActiveTime: 0,
    data: undefined
  };
  var startTime;
  var latestCompletion;
  var lastSlide;
  var slideCount = 0;
  var completionCount = 0;
  processedData.data = (0, _lodash.sortBy)(progress.filter(function (s) {
    if (ignoreConclusion && s.type === Conclusion) {
      return false;
    }
    if (ignoreExplanation && s.type === Explanation) {
      return false;
    }
    if (s.type !== Conclusion) {
      slideCount += 1;
    }
    return true;
  }).map(function (s) {
    if (!startTime) {
      startTime = s.started;
    }
    var summations = {
      elapsed: 0,
      total: 0
    };
    processedData.totalSlides += 1;
    var timesByLastActive = new Map();
    var keys = [];
    var useLegacyLogic = true;
    if (s.elapsedTime) {
      // Build out map keyed by lastActive times, where each key
      // is an array of times (if length > 1, these are the times
      // a status was sent where a user was not performing some action
      s.elapsedTime.forEach(function (t) {
        var lastActive = t.lastActive,
          eventType = t.eventType;
        if (lastActive) {
          if (!timesByLastActive.has(lastActive)) {
            timesByLastActive.set(lastActive, []);
          }
          var arr = timesByLastActive.get(lastActive);
          if (arr) {
            arr.push(t);
          }
        }
        if (eventType) {
          useLegacyLogic = false;
        }
      });

      // Sort by lastActive, earliest to latest
      keys = (0, _lodash.sortBy)(Array.from(timesByLastActive.keys()), function (a, b) {
        return +new Date(a) - +new Date(b);
      });
    }

    // If useLegacyLogic is true, that means all timestamps
    // did not have an eventType, which is used for calculating
    // the times for the new logic
    if (useLegacyLogic) {
      console.log('Did not find timestamps with eventTypes; Using old logic...');
      if (s.finished && s.started) {
        var duration = +new Date(s.finished) - +new Date(s.started);
        processedData.totalTime += duration;
        summations.total = duration;
        processedData.slidesCompleted += 1;
      }
      if (s.elapsedTime && s.started) {
        var _duration = 0;
        var prevTime = {
          timestamp: s.started,
          lastActive: s.started
        };

        // Iterate through each list of times by lastActive
        // and sum up the differences
        keys.forEach(function (k) {
          var times = timesByLastActive.get(k);
          if (times) {
            times.forEach(function (t) {
              if (!t.isStart && t.timestamp && prevTime.timestamp) {
                var diff = +new Date(t.timestamp) - +new Date(prevTime.timestamp);
                _duration += diff;
              }
              prevTime = t;
            });
          }
        });
        processedData.totalActiveTime += _duration;
        summations.elapsed = _duration;
      }
    } else if (s.elapsedTime) {
      var sortedElapsedTime = (0, _lodash.sortBy)(s.elapsedTime, ['lastActive', 'timestamp']);
      var completeTime;
      var leftReviewTime;
      var _prevTime;
      var skippedSameLastActive = false;
      sortedElapsedTime.forEach(function (t) {
        var eventType = t.eventType,
          timestamp = t.timestamp,
          lastActive = t.lastActive;

        // Only attempt to process if prevTime exists
        if (_prevTime) {
          //  If prevTime.eventType is not N(ext), B(ack), or X(stop), or if current eventType is not S(tart)
          if (![_constants.TimeEventTypes.Next, _constants.TimeEventTypes.Back, _constants.TimeEventTypes.Stop].includes(_prevTime.eventType || '')) {
            if (eventType !== _constants.TimeEventTypes.Start) {
              // If the prevTime's lastActive is the same as current,
              // skip because this is the user not moving so we will
              // take a difference of timestamp - lastActive at a later point
              if (_prevTime.lastActive === lastActive) {
                skippedSameLastActive = true;
              } else {
                var _duration2 = +new Date(timestamp) - +new Date(_prevTime.timestamp);
                // Ignore duration if greater than 35 seconds
                if (_duration2 <= ThirtyFiveSecs) {
                  sumDuration(summations, _duration2, leftReviewTime);
                } else {
                  var _prevTime2;
                  // eslint-disable-next-line no-console
                  console.log("Duration between timestamps greater than 35 seconds (".concat(_duration2, "ms), ignoring - Id1: '").concat((_prevTime2 = _prevTime) === null || _prevTime2 === void 0 ? void 0 : _prevTime2._id, "', Id2: '").concat(t === null || t === void 0 ? void 0 : t._id, "'"));
                }
                if (skippedSameLastActive) {
                  var lastActiveDuration = +new Date(_prevTime.timestamp) - +new Date(_prevTime.lastActive);
                  skippedSameLastActive = false;
                  sumDuration(summations, lastActiveDuration, leftReviewTime, true);
                }
              }
            }
          } else if (skippedSameLastActive) {
            // This likely will never get hit, but is here as a safeguard
            // if skippedSameLastActive is somehow true/didn't get cleared above
            var _lastActiveDuration = +new Date(_prevTime.timestamp) - +new Date(_prevTime.lastActive);
            skippedSameLastActive = false;
            sumDuration(summations, _lastActiveDuration, leftReviewTime, true);
          }
        }
        if (eventType === _constants.TimeEventTypes.Complete && !completeTime) {
          completeTime = t;
          completionCount += 1;
          if (s.type !== Conclusion && (!latestCompletion || latestCompletion.timestamp < completeTime.timestamp)) {
            latestCompletion = completeTime;
            lastSlide = s;
          }
        }
        if (([_constants.TimeEventTypes.Next, _constants.TimeEventTypes.Back, _constants.TimeEventTypes.Stop].includes(eventType || '') || _prevTime && _constants.TimeEventTypes.Start === eventType) && completeTime && !leftReviewTime) {
          leftReviewTime = t;
        }
        _prevTime = t;
      });

      // If the last time in the list was an interval ping and
      // the user was inactive and subsequently left without doing some action
      // (perhaps caused by a computer crash, etc.),
      // then we need to record that inactive time
      if (_prevTime && skippedSameLastActive) {
        var lastActiveDuration = +new Date(_prevTime.timestamp) - +new Date(_prevTime.lastActive);
        skippedSameLastActive = false;
        sumDuration(summations, lastActiveDuration, leftReviewTime, true);
      }
      if (summations.elapsed) {
        processedData.totalActiveTime += summations.elapsed;
      }
    }
    var data = _objectSpread(_objectSpread(_objectSpread({}, s), summations), {}, {
      answers: [],
      percentCorrect: 0
    });
    var length = s.selectionsPerTry.length;
    s.selectionsPerTry.forEach(function (spt, i) {
      var index = i + 1;
      var tryData = spt.join(', ');
      data["try".concat(index)] = tryData;
      if (index > processedData.numTries) {
        processedData.numTries = index;
      }

      // Last try
      if (i === length - 1) {
        var slideSelectionsLength = (s.slideSelections || []).length || 0;
        if (s.type !== ClickBestSpot) {
          if (s.isSingle) {
            data.percentCorrect = s.correct ? 1 : 0;
            for (var l = 0; l < slideSelectionsLength; l += 1) {
              var sel = s.slideSelections ? s.slideSelections[l] : undefined;
              if (sel && sel.correct && data.answers) {
                data.answers.push(l + 1);
                data.answerKey = data.answers.join(', ');
                break;
              }
            }
          } else {
            var answeredCorrectly = 0;
            (s.slideSelections || []).forEach(function (sel, j) {
              var answerIndex = j + 1;
              if (sel.correct && data.answers) {
                data.answers.push(answerIndex);
              }
              if (spt.includes(answerIndex) && sel.correct || !spt.includes(answerIndex) && !sel.correct) {
                answeredCorrectly += 1;
              }
            });
            data.percentCorrect = slideSelectionsLength ? answeredCorrectly / slideSelectionsLength : undefined;
            data.answerKey = (data.answers || []).join(', ');
          }
        } else {
          data.percentCorrect = s.correct ? 1 : 0;
          data.answerKey = 'N/A';
        }
      }
    });
    return data;
  }), 'order');

  // Determine total time spent in module
  if (startTime && latestCompletion && (_lastSlide = lastSlide) !== null && _lastSlide !== void 0 && _lastSlide.elapsedTime && completionCount === slideCount) {
    var prevTime;
    var completeTime;
    var leftReviewTime;
    var sortedElapsedTime = (0, _lodash.sortBy)(lastSlide.elapsedTime, ['lastActive', 'timestamp']);
    sortedElapsedTime.forEach(function (t) {
      var eventType = t.eventType;
      if (eventType === _constants.TimeEventTypes.Complete && !completeTime) {
        completeTime = t;
      }
      if (([_constants.TimeEventTypes.Next, _constants.TimeEventTypes.Back, _constants.TimeEventTypes.Stop].includes(eventType || '') || prevTime && _constants.TimeEventTypes.Start === eventType) && completeTime && !leftReviewTime) {
        leftReviewTime = t;
      }
      prevTime = t;
    });
    if (!leftReviewTime) {
      leftReviewTime = prevTime;
    }
    if (prevTime) {
      processedData.totalTime = +new Date(prevTime.timestamp) - +new Date(startTime);
    }
  }
  return processedData;
};
exports.processProgressData = processProgressData;
var exportUserProgressToExcel = function exportUserProgressToExcel(_ref2) {
  var firstName = _ref2.firstName,
    lastName = _ref2.lastName,
    email = _ref2.email,
    progress = _ref2.progress,
    moduleName = _ref2.moduleName,
    outputFile = _ref2.outputFile;
  var totalTime = progress.totalTime,
    totalActiveTime = progress.totalActiveTime,
    data = progress.data,
    numTries = progress.numTries;
  var worksheetData = [];
  worksheetData.push(['Last Name:', lastName, null, 'LEGEND:']);
  worksheetData.push(['First Name:', firstName, null, '"Active Time" is an approximation of how long a user was active in each slide until completing and leaving the slide. (Time spent after returning to a completed slide does not count toward Active Time, but time spent after returning to an incomplete slide does. There is a 10-minute (+/- 30 seconds) idle timeout if no mouse activity occurs in the window, after which the timer is reactivated when mouse activity is detected.)']);
  worksheetData.push(['Email:', email, null, '"Total Active Time" is a summation of the Active Time for all slides in a module.']);
  worksheetData.push(['Module Name:', moduleName, null, '"Total Time" is the time period beginning when a user first starts the first slide in a module and ending when a user last exits the module.']);
  worksheetData.push(['Total Time (h:mm:ss):', msToExcelTime(totalTime)]);
  worksheetData.push(['Total Active Time (h:mm:ss):', msToExcelTime(totalActiveTime)]);
  var totalCorrect = 0;
  var totalExercises = 0;
  var processedData = [];
  data === null || data === void 0 ? void 0 : data.forEach(function (d, i) {
    var arrayData = [];
    var row = {
      num: i + 1,
      correct: 'Not Started',
      percentCorrect: d.percentCorrect || 0,
      choices: 'Not Started',
      answerKey: d.answerKey || '',
      elapsed: 0
    };
    if (d.type === Explanation) {
      if (d.finished) {
        row.correct = 'Completed';
      } else if (d.started) {
        row.correct = 'In Progress';
      }
      row.choices = 'N/A';
    } else {
      var choices = [];
      if (d.correct || d.correct === false) {
        if (d.correct) {
          totalCorrect += 1;
        }
        totalExercises += 1;
        row.correct = d.correct ? 'Correct' : 'Incorrect';
        for (var j = 1; j <= numTries; j += 1) {
          var tryData = d["try".concat(j)];
          if (d.type !== ClickBestSpot) {
            if (tryData && tryData.length) {
              choices.push(numTries === 1 ? tryData : "(".concat(tryData, ")"));
            }
          } else if (j === numTries) {
            choices.push(row.correct);
          }
        }
        row.choices = choices.join(', ');
      } else if (d.elapsed) {
        row.correct = 'In Progress';
        row.choices = 'In Progress';
      }
    }
    if (d.elapsed) {
      row.elapsed = msToExcelTime(d.elapsed);
    }
    ProgressColumns.forEach(function (c) {
      return arrayData.push(row[c.prop]);
    });
    processedData.push(arrayData);
  });
  worksheetData.push(['Total Score:', "".concat((totalCorrect / totalExercises * 100.0).toFixed(2), "%")]);
  worksheetData.push(ProgressColumns.map(function (c) {
    return c.name;
  }));
  worksheetData.push.apply(worksheetData, processedData);
  var worksheet = _xlsx["default"].utils.aoa_to_sheet(worksheetData);
  processedData.forEach(function (d, i) {
    var index = i + 9;
    if (worksheet["C".concat(index)]) {
      worksheet["C".concat(index)].z = '0%';
    }
    if (worksheet["F".concat(index)]) {
      worksheet["F".concat(index)].z = 'h:mm:ss';
    }
  });
  worksheet.B5.z = 'h:mm:ss';
  worksheet.B6.z = 'h:mm:ss';
  worksheet['!cols'] = [{
    width: 25
  }, {
    width: 20
  }, {
    width: 20
  }, {
    width: 20
  }];
  var workbook = _xlsx["default"].utils.book_new();
  _xlsx["default"].utils.book_append_sheet(workbook, worksheet, 'User Progress');
  if (outputFile) {
    var fileName = typeof outputFile === 'string' ? outputFile : 'user_progress.xlsx';
    _xlsx["default"].writeFile(workbook, fileName);
  } else {
    var content = _xlsx["default"].write(workbook, {
      type: 'buffer',
      bookType: 'xlsx'
    });
    return content;
  }
};
exports.exportUserProgressToExcel = exportUserProgressToExcel;